let db_results = {
    db_errors: [
        {code: 0, description: ''},
        {code: -5, description: 'Old password is the same as new password.'}
    ]
}

export default db_results